<template>
  <div id="applicant-edit-tab-internal-history">
    <div class="applicant-show-form">
      <ResubmissionPage type="APPLICANT" :resource-id="$route.params.id" />
    </div>
  </div>
</template>

<script>
import ResubmissionPage from "./actions/Resubmission.vue";

export default {
  components: {
    ResubmissionPage
  }
};
</script>
